import Layout from '@layout/Index'

export const customerProject = [
  {
    path: '/customer-project',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table/:customerid',
      },
      {
        path: 'table/:customerid',
        component: () => import(/* webpackChunkName: "CustomerProjectTable" */ './pages/CustomerProjectTable.vue'),
        name: '客户项目管理',
        meta: {
          title: '客户项目管理',
        },
      },
      {
        path: 'create/:customerid',
        component: () => import(/* webpackChunkName: "CustomerProjectForm" */ './pages/CustomerProjectForm.vue'),
        name: '新增客户项目信息',
        meta: {
          title: '新增客户项目信息',
        },
      },
      {
        path: 'update/:customerid/:id',
        component: () => import(/* webpackChunkName: "CustomerProjectForm" */ './pages/CustomerProjectForm.vue'),
        name: '修改客户项目信息',
        meta: {
          title: '修改客户项目信息',
          isUpdate: true,
        },
      },
      {
        path: 'create/:customerid/:id',
        component: () => import(/* webpackChunkName: "CustomerProjectForm" */ './pages/CustomerProjectForm.vue'),
        name: '复制客户项目信息',
        meta: {
          title: '新增客户项目信息',
        },
      },
      {
        path: 'audit/:customerid/:id',
        component: () => import(/* webpackChunkName: "CustomerProjectForm" */ './pages/CustomerProjectApproveDetail.vue'),
        name: '审核客户项目信息',
        meta: {
          title: '审核客户项目信息',
        },
      },
      {
        path: 'finance/update/:customerid/:id',
        component: () => import(/* webpackChunkName: "CustomerProjectForm" */ './pages/ProjectFinanceForm.vue'),
        name: '修改客户项目财务信息',
        meta: {
          title: '修改客户项目财务信息',
        },
      },
      {
        path: 'flow/table/:customerid/:id',
        component: () => import(/* webpackChunkName: "CustomerProjectForm" */ './pages/ProjectFlowTable.vue'),
        name: '项目明细',
        meta: {
          title: '项目明细',
        },
      },
      {
        path: 'budget/table/:customerid/:id',
        component: () => import(/* webpackChunkName: "CustomerProjectForm" */ './pages/ProjectBudgetTable.vue'),
        name: '项目预算修改历史',
        meta: {
          title: '项目预算修改历史',
        },
      },
      {
        path: 'usebudget/detail/:customerid/:id',
        component: () => import(/* webpackChunkName: "CustomerProjectForm" */ './pages/CustomerBudgetUseDetail.vue'),
        name: '预算使用情况',
        meta: {
          title: '预算使用情况',
        },
      }
    ],
  },
  {
    path: '/project',
    component: Layout,
    children: [
      {
        path: 'table/:id',
        component: () => import(/* webpackChunkName: "CustomerProjectTable" */ './pages/ProjectTable.vue'),
        name: '项目管理',
        meta: {
          title: '项目管理',
          type: 'customer-project-table',
        },
      },
      {
        path: 'ajx/table/:id',
        component: () => import(/* webpackChunkName: "CustomerProjectTable" */ './pages/AjxProjectTable.vue'),
        name: '爱绩效项目管理',
        meta: {
          title: '爱绩效项目管理',
        },
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/customer-project/customer-project.route.js